import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=d6c519e4"
import script from "./err404.vue?vue&type=script&lang=js"
export * from "./err404.vue?vue&type=script&lang=js"
import style0 from "./err404.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports